<script>

  export default {
    name: 'loading',
    data () {
      return {
        tick: 0,
      }
    },
    computed: {
      phrase () {
        return this.tick % 4
      },
    },
    mounted () {
      this.changeLetter()
    },
    methods: {
      changeLetter () {
        setTimeout(() => {
          this.tick++
          this.changeLetter()
        }, 250)
      },
    },
  }
</script>

<template lang="pug">

div.search-input
  h3.title.is-2
    b.white Robert
  h4.subtitle.is-3
    transition(name="fade")
      span(v-if="tick <= 15", key="1") veut lire lance son algorithme.
      span(v-else-if="tick <= 30", key="2") fouille dans ses bases de données.
      span(v-else-if="tick <= 45", key="3") veut lire analyse le contexte du livre.
      span(v-else-if="tick <= 60", key="4") compile les résultats.
</template>

<style lang="postcss" scoped>

  .loading {

  }
</style>



// WEBPACK FOOTER //
// loading.vue?13f04168